import React from 'react';
import { I18n } from 'react-redux-i18n';
import priceFormatting from '../../../utils/priceFormatting';

// Aggregated "chiffres clés" for the Comptes clients view.
// Computed globally over the whole customer base (insensitive to filters/search),
// from the same `account_details` data (_dim_customer) that feeds the table.
// No extra API call — we reduce over the already-loaded accounts list.
const KeyFigures = ({ accounts }) => {
	const flatAccounts = (accounts || []).flat();

	const totals = flatAccounts.reduce(
		(acc, account) => {
			const d = account.account_details || {};
			acc.turnover += Number(d.turnover) || 0;
			acc.visit += Number(d.visit) || 0;
			acc.nb_guests += Number(d.nb_guests) || 0;
			acc.nb_bookings += Number(d.nb_bookings) || 0;
			acc.discount += Number(d.discount) || 0;
			acc.offered += Number(d.offered) || 0;
			return acc;
		},
		{ turnover: 0, visit: 0, nb_guests: 0, nb_bookings: 0, discount: 0, offered: 0 }
	);

	// Weighted global averages (ΣTTC / Σvisites, ΣTTC / Σcouverts) — never an average of averages.
	const orderAverage = totals.visit > 0 ? totals.turnover / totals.visit : 0;
	const guestAverage = totals.nb_guests > 0 ? totals.turnover / totals.nb_guests : 0;

	const eur = (value) => priceFormatting(value, 'en', 'EUR');
	const nb = (value) => new Intl.NumberFormat('fr-FR').format(Math.round(value));

	const cards = [
		{ id: 'turnover', label: I18n.t('customerAccount.turnover'), value: eur(totals.turnover) },
		{ id: 'visit', label: I18n.t('customerAccount.visit'), value: nb(totals.visit) },
		{ id: 'nb_guests', label: I18n.t('customerAccount.nb_guests'), value: nb(totals.nb_guests) },
		{ id: 'nb_bookings', label: I18n.t('customerAccount.nb_bookings'), value: nb(totals.nb_bookings) },
		{ id: 'order_average', label: I18n.t('customerAccount.order_average'), value: eur(orderAverage) },
		{ id: 'guest_average', label: I18n.t('customerAccount.guest_average'), value: eur(guestAverage) },
		{ id: 'discount', label: I18n.t('customerAccount.discount'), value: eur(totals.discount), accent: true },
		{ id: 'offered', label: I18n.t('customerAccount.offered'), value: eur(totals.offered), accent: true },
	];

	return (
		<div className="key-figures">
			<div className="key-figures-head">
				<span className="key-figures-title">{I18n.t('customerAccount.keyFigures')}</span>
				<span className="key-figures-scope">{I18n.t('customerAccount.keyFiguresScope')}</span>
			</div>
			<div className="key-figures-cards">
				{cards.map((card) => (
					<div
						key={card.id}
						className={`key-figure-card${card.accent ? ' accent' : ''}`}>
						<span className="key-figure-label">{card.label}</span>
						<span className="key-figure-value">{card.value}</span>
					</div>
				))}
			</div>
		</div>
	);
};

export default KeyFigures;
